import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { confirmation } from 'redux-form-validators';

import {
    FormComponent,
    PasswordInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { PATH } from '../../../constants/path';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { passwordResetCommit } from '../../../services/authentication/resetpassword/actions';

import './PasswordResetCommitFormComponent.scss';

class PasswordResetCommitFormComponent extends React.Component {
    handleSubmit = data => {
        this.props.passwordResetCommit(
            data,
            this.props.match.params.email,
            this.props.match.params.token
        );
    };

    renderForm = () => {
        const { i18n, requestSubmit, successSubmit, errorSubmit, errorMessage } = this.props;
        if (!successSubmit) {
            return (
                <FormComponent
                    form="password-reset-commit-form"
                    classNameInputContainer="grid-2 has-gutter"
                    onSubmit={this.handleSubmit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.form.SUBMIT}>
                    <PasswordInputFieldComponent
                        name="password"
                        label={i18n.form.placeholder.PASSWORD}
                        placeholder={i18n.form.placeholder.PASSWORD}
                        isRequired
                        validate={[confirmation({ field: 'confirmation', msg: ' ' })]}
                    />
                    <PasswordInputFieldComponent
                        name="confirmation"
                        label={i18n.form.placeholder.PASSWORD_CONFIRM}
                        placeholder={i18n.form.placeholder.PASSWORD_CONFIRM}
                        isRequired
                        validate={[
                            confirmation({
                                field: 'password',
                                msg: i18n.form.PASSWORD_CONFIRM_ERROR
                            })
                        ]}
                    />
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        }
    };

    renderMessageSubmit = () => {
        const { successSubmit, i18n } = this.props;
        if (successSubmit) {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.form.SUCCESS_MESSAGE}</p>
                </SuccessInfoComponent>
            );
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-reset-password-commit">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={`${PATH.PASSWORD_RESET_PATH}/:email/:token`}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <p className="subtitle">{i18n.SUBTITLE}</p>
                {this.renderForm()}
                {this.renderMessageSubmit()}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.PASSWORDRESET.COMMIT,
        errorMessage: state.authentication.resetpassword.errorPasswordResetCommit || '',
        requestSubmit: state.authentication.resetpassword.fetchingPasswordResetCommit || false,
        successSubmit: state.authentication.resetpassword.successPasswordResetCommit || false,
        errorSubmit: !isEmpty(state.authentication.resetpassword.errorPasswordResetCommit)
    };
};

const mapDispatchToProps = {
    passwordResetCommit
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(PasswordResetCommitFormComponent),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/resetpassword/PasswordResetCommitFormComponent.js